module.exports = __webpack_public_path__ + "static/media/Atom.e49960a6.svg";